




import {Vue, Component} from "vue-property-decorator";

@Component
export default class PreLogin extends Vue{
  created() {
    this.$router.onReady(() => {
      this.$setNavInfo({
        showNavBar: false,
      })
    });
  }
}
